// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import { IonCol, IonGrid, IonRow, IonText } from "@ionic/react"


const FeatureNotAvailable: React.FC = () => {
  const {gettext} = useLocales()
  return (
    <IonGrid style={{paddingTop: "var(--section-padding)"}}>
      <IonRow className="panel">
        <IonCol>
          <IonText>
            {gettext("Deze functionaliteit is momenteel niet beschikbaar.")}
          </IonText>
        </IonCol>
      </IonRow>
    </IonGrid>
  )
}


export default FeatureNotAvailable